import React, { Component } from "react";
import { connect } from "react-redux";
import { authWatch, authLogin } from "../../actions/authActions";

import produce from "immer";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: "",
      pw: ""
    };
  }

  componentDidMount() {
    this.props.authWatch();
  }

  componentDidUpdate(prevProps, prevState) {
    const { user: prevUser, loginFail: prevLoginFail } = prevProps.auth;
    const { user, loginFail } = this.props.auth;
    const { uid } = user || {};

    if (uid && prevUser !== user) {
      console.log("login");
    }

    if (!prevLoginFail && loginFail) {
      window.confirm("로긴 실패");
    }
  }

  handleChange = e => {
    const { value, name } = e.target;
    this.setState(
      produce(draft => {
        draft[name] = value;
      })
    );
  };

  handleSubmit = e => {
    e.preventDefault();
    const { id, pw } = this.state;
    this.props.authLogin(id, pw);
    this.setState((prevState, props) => ({
      id: "",
      pw: ""
    }));
  };

  render() {
    const { id, pw } = this.state;
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="w-100" style={{ maxWidth: 500 }}>
          <form onSubmit={this.handleSubmit}>
            <div className="form-group row">
              <label htmlFor="staticEmail" className="col-sm-2 col-form-label">
                Email
              </label>
              <div className="col-sm-10">
                <input
                  type="text"
                  name="id"
                  className="form-control"
                  id="staticEmail"
                  onChange={this.handleChange}
                  value={id}
                />
              </div>
            </div>
            <div className="form-group row">
              <label
                htmlFor="inputPassword"
                className="col-sm-2 col-form-label"
              >
                Password
              </label>
              <div className="col-sm-10">
                <input
                  type="password"
                  name="pw"
                  className="form-control"
                  id="inputPassword"
                  onChange={this.handleChange}
                  value={pw}
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-sm-10 ml-auto">
                <button
                  disabled={id === "" || pw === ""}
                  type="submit"
                  className="btn btn-primary btn-block"
                >
                  로그인
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(
  mapStateToProps,
  { authWatch, authLogin }
)(Login);
